// Import services using ES6 to match export format
import { suggestionService } from './services/suggestionService';
import { accommodationDateChangeDetector } from './services/accommodationDateChangeDetector';

// Export services using ES6 for consistency with other packages
export { suggestionService, accommodationDateChangeDetector };

// Export React components directly using ES6 import/export
export { default as GenericSuggestionPopup } from './components/GenericSuggestionPopup.jsx';

// Deferred initialization — called by App.js after all packages are loaded
// Matches the pattern of initDaysServices, initAccommodationServices, etc.
export const initSuggestionsServices = () => {
  suggestionService.init();
};
